// extracted by mini-css-extract-plugin
module.exports = {"sep":"separator_sep__25XO9","sepText":"separator_sepText__2IIJR","vertical":"separator_vertical__3IfyH"};